// ===== Toggle: TypeScript (active) =====
import HomeContainer from '@porterin/feature/src/containers/home/view/HomeContainer.tsx';
export { getStaticProps } from '@porterin/feature/src/containers/home/data-fetchers/HomeDataFetcher.ts';

// ===== Toggle: ReScript (inactive — uncomment to revert) =====
// import HomeContainer from '@porterin/feature/src/containers/home/view/HomeContainer.mjs';
// export { getStaticProps } from '@porterin/feature/src/containers/home/data-fetchers/HomeDataFetcher.mjs';

import MainLayout from '@porterin/feature/src/layouts/main-layout/MainLayout.tsx';
export default function Home(props) {
  let { header_data, footer_data, page_data, fare_estimate_form_content } =
    props;

  return (
    <MainLayout
      header_data={header_data}
      footer_data={footer_data}
      meta_data={page_data.meta_data}
    >
      <HomeContainer
        page_data={page_data}
        fare_estimate_form_content={fare_estimate_form_content}
      />
    </MainLayout>
  );
}
